import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Row, TextButton, Typography } from 'seagull';
import { AnchorLogo, Eye } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './InvoiceSummaryPanel.module.scss';
export const GetInvoiceSummaryPanelTID = (parentTestId)=>getTestIds(parentTestId);
export const InvoiceSummaryPanel = (param)=>{
    let { vendorName, vendorLogoUrl, vendorAddress, clientName, invoiceNumber, issueDate, dueDate, amountDue, onViewInvoiceClick, hideVendorBlock, mobile, testId } = param;
    const { InvoiceSummaryPanelTestIds } = useMemo(()=>GetInvoiceSummaryPanelTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const detailVariant = mobile ? 'paragraph1' : 'paragraph2';
    const amountVariant = mobile ? 'h4' : 'paragraph1';
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": InvoiceSummaryPanelTestIds.Root(),
        className: cn(styles.panel, mobile && styles.panelMobile),
        children: [
            hideVendorBlock !== true && /*#__PURE__*/ _jsxs("div", {
                className: styles.vendorBlock,
                children: [
                    vendorLogoUrl != null && /*#__PURE__*/ _jsx("img", {
                        "data-testid": InvoiceSummaryPanelTestIds.VendorLogo(),
                        src: vendorLogoUrl,
                        alt: vendorName,
                        className: styles.vendorLogo
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.vendorText,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                weight: "bold",
                                testId: InvoiceSummaryPanelTestIds.VendorName(),
                                children: vendorName
                            }),
                            vendorAddress != null && /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph3",
                                weight: "light",
                                testId: InvoiceSummaryPanelTestIds.VendorAddress(),
                                className: styles.vendorAddress,
                                children: vendorAddress
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.detailsBlock, hideVendorBlock && styles.detailsBlockNoBorder, mobile && styles.detailsBlockMobile),
                children: [
                    clientName != null && /*#__PURE__*/ _jsxs("div", {
                        className: cn(styles.row, mobile && styles.rowMobile),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                skin: "secondary",
                                children: t.adHocInvoiceApproval.invoiceSummary.clientName()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                testId: InvoiceSummaryPanelTestIds.ClientName(),
                                children: clientName
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn(styles.row, mobile && styles.rowMobile),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                skin: "secondary",
                                children: t.adHocInvoiceApproval.invoiceSummary.invoiceNumber()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                testId: InvoiceSummaryPanelTestIds.InvoiceNumber(),
                                children: invoiceNumber
                            })
                        ]
                    }),
                    issueDate != null && /*#__PURE__*/ _jsxs("div", {
                        className: cn(styles.row, mobile && styles.rowMobile),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                skin: "secondary",
                                children: t.adHocInvoiceApproval.invoiceSummary.issueDate()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                testId: InvoiceSummaryPanelTestIds.IssueDate(),
                                children: issueDate
                            })
                        ]
                    }),
                    dueDate != null && /*#__PURE__*/ _jsxs("div", {
                        className: cn(styles.row, mobile && styles.rowMobile),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                skin: "secondary",
                                children: t.adHocInvoiceApproval.invoiceSummary.dueDate()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: detailVariant,
                                testId: InvoiceSummaryPanelTestIds.DueDate(),
                                children: dueDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.amountRow,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: amountVariant,
                                weight: "bold",
                                children: t.adHocInvoiceApproval.invoiceSummary.amountDue()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: amountVariant,
                                weight: "bold",
                                testId: InvoiceSummaryPanelTestIds.AmountDue(),
                                children: amountDue.display()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.divider
            }),
            /*#__PURE__*/ _jsxs(Row, {
                className: styles.viewInvoiceLink,
                children: [
                    /*#__PURE__*/ _jsx(Eye, {
                        size: mobile ? 20 : 18
                    }),
                    /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'ad_hoc_invoice_view_invoice'
                        },
                        testId: InvoiceSummaryPanelTestIds.ViewInvoiceLink(),
                        variant: mobile ? 'paragraph1' : 'paragraph2',
                        onClick: onViewInvoiceClick,
                        children: t.adHocInvoiceApproval.viewInvoice()
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("a", {
                "data-testid": InvoiceSummaryPanelTestIds.PoweredByAnchor(),
                href: "https://www.sayanchor.com/?utm_channel=product&utm_source=product&utm_medium=web&utm_campaign=9856721346-client_invoice_on_demand_payment_link",
                target: "_blank",
                rel: "noopener noreferrer",
                className: styles.poweredBy,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        weight: "normal",
                        children: t.adHocInvoiceApproval.poweredBy()
                    }),
                    /*#__PURE__*/ _jsx(AnchorLogo, {
                        theme: "dark",
                        height: 24
                    })
                ]
            })
        ]
    });
};
